import React from 'react';
import '../styles/Loader.scss';


export default function Loader() {
    return (
        <div className="loader-wrap" role="status" aria-live="polite">
            <div className="spinner" />
        </div>
    );
}